import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD5pbRe_sj1AiQQCIMJSaKbWMz578YHLP4"
  }
});
